export default "__VITE_ASSET__BliAOI5S__"